<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="contacts" /> Department Group
        </span>
        <a-input
          v-model="filter.query"
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
        />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add
        </a-button>
      </div>
      <a-table
        class="top-table"
        :columns="columnsAllDepartmentGroup"
        :data-source="departmentGroup"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <a
          slot="titleType"
          slot-scope="text, record"
          @click="collapseVisibleDetail(record.id)"
        >
          {{ text }}
        </a>
        <a slot="no" slot-scope="text, record, index">
          {{ index + 1 }}
        </a>
        <span slot="departments" slot-scope="text, record">
          <span v-for="(department, index) in record.departments" :key="index">
            <div>{{ index + 1 }}. {{ department.name }}</div>
          </span>
        </span>
        <span slot="author" slot-scope="text">
          {{ text.author && (text.author.fullname || text.author.username) }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
      </a-table>
    </a-card>

    <a-drawer
      v-if="visibleEdit"
      title="Edit"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <EditDepartmentGroup
        :idDepartmentGroup="idDepartmentGroup"
        :close="() => (visibleEdit = false)"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
      />
    </a-drawer>

    <a-drawer
      v-if="visibleAdd"
      title="Add"
      placement="right"
      :visible="visibleAdd"
      @close="() => (visibleAdd = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddDepartmentGroup
        :close="() => (visibleAdd = false)"
        :refreshAfterCreated="refreshAfterCreated"
      />
    </a-drawer>
  </div>
</template>
<script>
import { columnsAllDepartmentGroup } from "./constant/column";
import AddDepartmentGroup from "./components/addDepartmentGroup";
import EditDepartmentGroup from "./components/editDepartmentGroup";
import query from "./constant/query";
import debouce from "lodash/debounce";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;

export default {
  components: { AddDepartmentGroup, EditDepartmentGroup },
  data() {
    this.onFilter = debouce(this.onFilter, 500);
    return {
      keySearch: "",
      visibleEdit: false,
      isPagination: true,
      visibleAdd: false,
      columnsAllDepartmentGroup,
      loadingList: true,
      departmentGroup: [],
      idDepartmentGroup: "",
      limit,
      currentPage: startPage,
      filter: {},
      totalPage: startPage,
    };
  },
  methods: {
    onGetAllDepartmentGroup(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListDepartmentGroup,
          fetchPolicy: "no-cache",
          variables: {
            limit: this.limit,
            page: this.currentPage,
            query: this.filter.query,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (flag === "PAGINATION") {
            if (
              data.getListDepartmentGroup?.length >= 0 &&
              this.departmentGroup?.length >= 0
            ) {
              this.departmentGroup = this.departmentGroup.concat([
                ...data.getListDepartmentGroup,
              ]);
            } else {
              this.departmentGroup = [...data.getListDepartmentGroup];
            }
          } else {
            if (data?.getListDepartmentGroup?.length >= 0) {
              this.departmentGroup = [...data.getListDepartmentGroup];
            }
          }

          // check is pagniation
          if (data.getListDepartmentGroup.length < limit) {
            this.isPagination = false;
          } else {
            this.isPagination = true;
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get info error!",
          });
          console.error("Lấy danh sách khách hàng không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idDepartmentGroup = id;
        this.visibleDetail = true;
      } else {
        this.idDepartmentGroup = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idDepartmentGroup = id;
        this.visibleEdit = true;
      } else {
        this.idDepartmentGroup = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.totalPage = startPage;
      this.currentPage = startPage;
      this.onGetAllDepartmentGroup("FILTER");
    },
    refreshAfterUpdated(item) {
      this.departmentGroup = updateForUpdated(this.departmentGroup, item);
    },
    refreshAfterDeleted(item) {
      this.departmentGroup = updateForDeleted(this.departmentGroup, item);
    },
    refreshAfterCreated(item) {
      this.departmentGroup = updateForCreated({
        list: this.departmentGroup,
        item,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllDepartmentGroup("PAGINATION");
      }
    },
  },
  created() {
    this.onGetAllDepartmentGroup();
  },
};
</script>
<style lang="css" scoped></style>
